import { render } from "./Colab.vue?vue&type=template&id=14a5941d"
import script from "./Colab.vue?vue&type=script&lang=js"
export * from "./Colab.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__